import type { AudioBarHeightRange } from './audio-bar.types';

export const AUDIO_BAR_OFFSET_PROPERTY = '--audio-bar-offset';
export const AUDIO_BAR_REST_OFFSET_PROPERTY = '--audio-bar-rest-offset';

const VISIBLE_HEIGHT_STEP_PX = 0.25;

export const audioBarHeightToOffset = (
  height: number,
  { min, max }: AudioBarHeightRange
): string => {
  const clamped = Math.min(Math.max(height, min), max);
  const visibleHeight =
    Math.round(clamped / VISIBLE_HEIGHT_STEP_PX) * VISIBLE_HEIGHT_STEP_PX;

  return `${((max - visibleHeight) / 2).toFixed(3)}px`;
};

export const restingAudioBarOffset = (range: AudioBarHeightRange): string =>
  audioBarHeightToOffset(range.min, range);

export const setAudioBarHeight = (
  bar: HTMLElement,
  height: number,
  range: AudioBarHeightRange
): boolean => {
  const offset = audioBarHeightToOffset(height, range);
  if (bar.style.getPropertyValue(AUDIO_BAR_OFFSET_PROPERTY) === offset) return false;

  bar.style.setProperty(AUDIO_BAR_OFFSET_PROPERTY, offset);
  return true;
};
